var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuckepack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.5,656.5h-63.5c-4.4,0-7-1.8-10.1-4.4-9.2-7-12.3-15.3-11.4-27.2.9-10.5,0-21.9,0-32.4s.9-4.4,4.4-4.4h131.4c3.1,0,4.8,1.3,7.4,3.1,9.6,7.4,14,16.7,12.7,29.8-.9,9.6,0,20.6,0,30.2s-1.3,5.7-5.7,5.7h-65.3v-.4h.1ZM395.2,636.8h52.1c4.4,0,5.3-1.3,4.8-5.3v-17.1c0-4.8-2.6-7.4-7.4-7.4h-105.6c-3.1,0-3.9.9-3.9,3.9v17.1c0,5.7,2.6,8.3,8.3,8.3h51.7v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.7,578.6c27.2,0,49.1,21.9,48.6,48.6,0,26.7-21.9,48.6-48.6,48.6s-48.6-21.9-48.6-48.6,21.9-48.2,48.6-48.6h0ZM150.7,655.7c16.2,0,29.4-13.1,29.4-29.4s-13.1-28.5-28.5-29.4c-16.2,0-29.4,12.7-29.4,28.5s12.7,29.8,28.5,29.8h0v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.6,578.6c26.7,0,48.6,21.5,48.6,47.8s-21,49.5-48.2,49.5-48.6-21.5-48.6-48.6,21.5-48.6,48.2-48.6h0ZM287,627.2c0-16.2-12.7-28.5-28.5-29.4-16.2,0-29.4,12.7-29.4,29.4s12.7,29.4,29.4,29.4,28.5-12.7,28.5-28.5h0v-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.4,647.8c-13.6,0-21-3.5-26.7-11.4-1.3-1.8-2.2-3.1-2.2-5.7v-32c0-3.1.9-3.9,3.9-3.9h32c4.8,0,7.9-1.3,7.9-6.6s.9-2.2,2.6-2.2h5.7c3.1,0,7-1.8,9.2,1.3s-.9,11.4-3.5,14.9c-6.6,8.8-14.9,11.8-25.4,10.5h-12.3c-4.4,0-3.1.9-3.1,3.1v7c0,5.7,1.8,7.4,7.4,7.4h32.4c3.1,0,3.9.9,3.9,3.9,0,9.2-4.4,14-13.6,14h-18.8.4v-.4h.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.6,
    y: 546.6,
    width: 426.3,
    height: 21.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M652.9,578.6c-27.2,0-49.1,21.9-48.6,48.6,0,26.7,21.9,48.6,48.6,48.6s48.6-21.9,48.6-48.6-21.9-48.2-48.6-48.6ZM652.9,655.7c-16.2,0-29.4-13.1-29.4-29.4s13.1-28.5,28.5-29.4c16.2,0,29.4,12.7,29.4,28.5s-12.7,29.8-28.5,29.8h0v.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546,578.6c-26.7,0-48.6,21.5-48.6,47.8s21,49.5,48.2,49.5,48.6-21.5,48.6-48.6-21.5-48.6-48.2-48.6h0ZM516.6,627.2c0-16.2,12.7-28.5,28.5-29.4,16.2,0,29.4,12.7,29.4,29.4s-12.7,29.4-29.4,29.4-28.5-12.7-28.5-28.5h0v-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M746.2,647.8c13.6,0,21-3.5,26.7-11.4,1.3-1.8,2.2-3.1,2.2-5.7v-32c0-3.1-.9-3.9-3.9-3.9h-32c-4.8,0-7.9-1.3-7.9-6.6s-.9-2.2-2.6-2.2h-5.7c-3.1,0-7-1.8-9.2,1.3s.9,11.4,3.5,14.9c6.6,8.8,14.9,11.8,25.4,10.5h12.3c4.4,0,3.1.9,3.1,3.1v7c0,5.7-1.8,7.4-7.4,7.4h-32.4c-3.1,0-3.9.9-3.9,3.9,0,9.2,4.4,14,13.6,14h18.8-.4v-.4h-.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 425.4,
    y: 546.6,
    width: 350.6,
    height: 21.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.7,
    y: 103,
    width: 751.3,
    height: 316.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuckepack);
export default __webpack_public_path__ + "static/media/huckepack.5a523e3d391761f1a2cc79ad5602053c.svg";
export { ForwardRef as ReactComponent };